module.exports = __webpack_public_path__ + "img/blueEdit.a2390bcf.svg";